import { Injectable } from "@angular/core";
import { AngularFirestore } from "@angular/fire/firestore";
import { UserApi } from "../api/user.api";
import { User } from "../models/user";
import { Observable } from "rxjs";
import { UserFilterService } from "./filter.service";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: "root"
})
export class UserService {
  private api: UserApi;

  public currentUser$: Observable<User>;
  public currentUser: User;
  public users$: Observable<User[]>;
  public filter: UserFilterService;

  public edit: User;

  constructor(public db: AngularFirestore, public httpClient: HttpClient) {
    this.api = new UserApi(db, httpClient);
    this.initAccountManagement();
    this.filter = new UserFilterService();
  }

  async getCurrentUser(id: string): Promise<void> {
    this.currentUser$ = this.api.get(id);
    this.currentUser$.subscribe(user => {
      this.currentUser = user;
    });
    return;
  }

  initAccountManagement() {
    this.users$ = this.api.getAuthorizedUsers();
    this.users$.subscribe(async users => {
      this.filter.init(users);
    });
  }

  get cities(): string[] {
    return this.currentUser.admin.cities != null
      ? this.currentUser.admin.cities
      : [];
  }

  get venues(): string[] {
    return this.currentUser.admin.venues != null
      ? this.currentUser.admin.venues
      : [];
  }

  editingUser = (user: User) => (this.edit = user);

  filterName = (name: string) => this.filter.search(name);

  async update(user: User): Promise<void> {
    await this.api.updateDB(user);
    this.api.updateClaims(user);
    return;
  }
  async updateUserInformation(info: {}): Promise<void> {
    let id = await this.getUserIdFromEmail(info["email"]);
    await this.api.db
      .collection("devUsers")
      .doc(id)
      .update(info);
    return;
  }

  createUser = (info: {}) => this.api.createUser(info);

  getUserIdFromEmail = (email: string): Promise<string> =>
    this.api.getUserIdFromEmail(email);

  async removeUserAccess(email: string) {
    let id = await this.getUserIdFromEmail(email);
    this.api.db
      .collection("devUsers")
      .doc(id)
      .update({ admin: null });
    this.api.removeClaims(id);
    return;
  }
}
